export default "__VITE_ASSET__CNczJqfR__"